/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {Link} from 'react-router'
import DefaultIcon from '../../images/lecturerInvite/item-none.png'

class DefaultContent extends React.Component {

    render() {
        const {urlData} = this.props;
        return (
            <div className="lecturer-invite-default">
                <div className="default-container">
                    <div className="default-icon">
                        <img src={DefaultIcon} alt=""/>
                    </div>
                    <div className="default-text">
                        <p>您还没有嘉宾</p>
                        <p>赶紧来邀请您的第一个嘉宾</p>
                    </div>
                    <a href={`/${urlData.type}/${urlData.target_id}/invite/card`}>
                        <div className="default-btn">
                            邀请嘉宾
                        </div>
                    </a>
                </div>
            </div>
        )
    }
}

export default DefaultContent


// WEBPACK FOOTER //
// ./src/components/lecturerInvite/DefaultContent.js